import { PaymentAccount } from './merchant';
import { ClueAutoAssignSwitch } from './clue';

// 门店信息
export type IStudioInfo = {
  id: number; // 门店 ID
  merchant_id: number; // 商户 ID
  name: string; // 名称
  start_time: string; // 开始时间
  end_time: string; // 结束时间
  image_arr: string[]; // 门店头图
  display_address: string; // 展示地址
  navigation_address: string; // 导航地址
  navigation_latitude: string; // 经度
  navigation_longitude: string; // 纬度
  navigation_tips: string; // 导航信息
  parking_tips: string; // 停车信息
  owner: string; // 所有者
  identification_number: string; // 社会编码
  classroom_num: number; // 教室数量
  status: number; // 状态
  create_time: string; // 创建时间
  class_rooms: IClassroomInfo[]; // 教室信息
  member_num: number; // 会员数量
  expire_member_num: number; // 过期会员数量
  check_in_qr_code: string; // 签到二维码
  payment_config_id: number; // 收款账户 ID
  payment_config: PaymentAccount; // 收款账户信息
  leads_auto_assign_admin_list: IStudioLeadsAutoAssignAdminList[]; // 线索自动分配员工列表
};

// 线索自动分配员工列表
export type IStudioLeadsAutoAssignAdminList = {
  id: number; // 员工 ID
  name: string; // 员工姓名
  is_leads_auto_assign: ClueAutoAssignSwitch; // 是否自动分配
};

// 教室信息
export type IClassroomInfo = {
  id: number; // 教室 ID
  store_id: number; // 门店 ID
  name: string; // 教室名
  capacity: number; // 教室容量
};

// 门店状态
export enum StudioStatus {
  ALL = 0, // 全部
  ONLINE = 1, // 在线
  OFFLINE = 2, // 下线
}
